/* eslint-disable camelcase */
export { default } from '@material-ui/core/Box'
